import { render, staticRenderFns } from "./AdminCarBrands.vue?vue&type=template&id=03f4d1a6&scoped=true"
import script from "./AdminCarBrands.vue?vue&type=script&lang=js"
export * from "./AdminCarBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f4d1a6",
  null
  
)

export default component.exports